class HomeCtrl {
  constructor($rootScope, featureFlags) {
    const ctrl: ng.IController = this;
    ctrl.$onInit = () => {
      ctrl.useNewDashboard = featureFlags.isOn('UTEST_DESIGN_REFRESH_2026');
      if (ctrl.user) {
        $rootScope.showAuthenticatedUtest = true;
      }
    };
  }
}

HomeCtrl.$inject = ['$rootScope', 'featureFlags'];

export default HomeCtrl;
